export enum NylasAuthenticationStatus {
  UnAuthenticated = 'UnAuthenticated',
  InvalidGrant = 'InvalidToken',
  Authenticated = 'Authenticated',
}
